import { useNavigate, useSearchParams } from 'react-router-dom';
import { Space } from 'antd';
import SearchFilter from '../../../components/ui/filters/SearchFilter';
import React, { useState } from 'react';
import DateRangeSelector from '../../../components/ui/filters/DateRangeFilter';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import { PlusOutlined } from '@ant-design/icons';
import {
  PurchaseOrderStatusEnums,
  RequestStatusEnum,
} from '../../../lib/enums';
import SelectFilter from '../../../components/ui/filters/SelectFilter';
import dayjs from 'dayjs';
import { dateFormat, isUserCanCreate } from '../../../lib/utils';
import { initialPurchaseRequestForm } from '../../../types/PurchaseRequest';
import { usePurchaseRequestStore } from '../../../store/PurchaseRequestStore';
import { useAuthStore } from '../../../store';

const PurchaseRequestHeaderFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    searchParams.get('status') || PurchaseOrderStatusEnums.ALL,
  );
  const navigate = useNavigate();
  const purchaseRequestStore = usePurchaseRequestStore();
  const { user } = useAuthStore();

  const startDate =
    searchParams.get('start') === undefined ||
    searchParams.get('start') === null
      ? dayjs().subtract(6, 'month').format(dateFormat)
      : searchParams.get('start');

  const endDate =
    searchParams.get('end') === undefined || searchParams.get('end') === null
      ? dayjs().add(2, 'month').format(dateFormat)
      : searchParams.get('end');
  const handleChange = (value: string) => {
    setSearchParams((prev) => {
      prev.set('status', value === undefined ? '' : value);
      return prev;
    });
    setSelectedValue(value);
  };
  const statusOptions: { value: string; label: string }[] = Object.keys(
    RequestStatusEnum,
  ).map(
    (key) =>
      ({
        value: RequestStatusEnum[key as keyof typeof RequestStatusEnum],
        label: RequestStatusEnum[key as keyof typeof RequestStatusEnum],
      }) as { value: string; label: string },
  );
  const isCurrentUserCanCreate = () => {
    return (
      user?.role === 'ROLE_ADMIN' ||
      isUserCanCreate(user?.moduleAccess, 'Purchase Request')
    );
  };
  return (
    <>
      <div className={'flex justify-between p-4'}>
        <Space direction="horizontal" size={12}>
          <SearchFilter />
          <DateRangeSelector startDate={startDate} endDate={endDate} />
          <SelectFilter
            handleChange={handleChange}
            defaultValue={selectedValue}
            dataOptions={statusOptions}
          />
        </Space>
        {isCurrentUserCanCreate() && (
          <PrimaryButton
            icon={<PlusOutlined />}
            onClick={() => {
              purchaseRequestStore.setFormData(initialPurchaseRequestForm);
              navigate('/purchase-request/request?action=create');
            }}
            label={'Create'}
          />
        )}
      </div>
    </>
  );
};

export default PurchaseRequestHeaderFilter;
